import React from 'react';
import './dragableDivider.scss';

export type DynamicSize = {
    x: number | undefined;
    y: number | undefined;
}

type ButtonProps = {
    onDrag: (x: number | undefined, y: number | undefined) => void;
    size: DynamicSize;
    revertDirection: boolean
}
export const DragableDivider = React.memo(({
                                               onDrag, size, revertDirection
                                           }: ButtonProps) => {

    const changeSize = (mouseDownEvent) => {
        const startSize = size;
        const startPosition = {x: mouseDownEvent.pageX, y: mouseDownEvent.pageY};

        function onMouseMove(mouseMoveEvent) {
            if (revertDirection) {
                onDrag(
                    startSize.x ? (startSize.x + startPosition.x - mouseMoveEvent.pageX) : undefined,
                    startSize.y ? (startSize.y + startPosition.y - mouseMoveEvent.pageY) : undefined
                );
            } else {
                onDrag(
                    startSize.x ? (startSize.x - startPosition.x + mouseMoveEvent.pageX) : undefined,
                    startSize.y ? (startSize.y - startPosition.y + mouseMoveEvent.pageY) : undefined
                );
            }
        }

        function onMouseUp() {
            document.body.removeEventListener('mousemove', onMouseMove);
            // uncomment the following line if not using `{ once: true }`
            // document.body.removeEventListener("mouseup", onMouseUp);
        }

        document.body.addEventListener('mousemove', onMouseMove);
        document.body.addEventListener('mouseup', onMouseUp, {once: true});
    };

    return <>
        <div className={'dragable-divider'} onMouseDown={changeSize}></div>
    </>;
});
